import { environment } from "./../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class BackendApiService {
  constructor(
    private httpClient: HttpClient // private http: Http,
  ) {}

  httpPostRequest(requestString: string, parameters: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/x-www-form-urlencoded",
      }),
    };
    return this.httpClient.post(
      environment.apiUrl.baseUrl + requestString,
      parameters,
      httpOptions
    );
  }

  getRequest(requestString: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/x-www-form-urlencoded",
      }),
    };
    return this.httpClient.get(environment.apiUrl.baseUrl + requestString);
  }

  postRawRequest(requestString: string, datas: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.httpClient.post(
      environment.apiUrl.baseUrl + requestString,
      JSON.stringify(datas),
      httpOptions
    );
  }

  postFormData(apiUrl: string, datas: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "undefined",
      }),
    };
    return this.httpClient.post(apiUrl, datas, httpOptions);
  }
  postRawRequestForVideo() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.httpClient.post(
      environment.apiUrl.baseVideoUrl + "getMediaDetails",
      JSON.stringify({}),
      httpOptions
    );
  }
  getData(): Observable<any> {
    return this.httpClient.get<any>('assets/data.json');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/backend-api.service.ts